<template>
<div>

  <TtiHeader></TtiHeader>

  <div class="relative bg-white">
    <div class="lg:absolute lg:inset-0">
      <div class="lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
        <img class="h-56 w-full object-cover lg:absolute lg:h-full" src="../assets/scott-graham-5fNmWej4tAA-unsplash.jpg" alt="">
      </div>
    </div>
    <div class="relative py-16 px-4 sm:py-24 sm:px-6 lg:px-8 lg:max-w-7xl lg:mx-auto lg:py-32 lg:grid lg:grid-cols-2">
      <div class="lg:pr-8">
        <div class="max-w-md mx-auto sm:max-w-lg lg:mx-0">
          <h2 class="text-3xl font-extrabold tracking-tight sm:text-4xl">
            Let us find a Tutor for you
          </h2>
          <p class="mt-4 text-lg text-gray-500 sm:mt-3">
            Whether it's too much choice, or too little, we can help find the perfect tutor for you. Make a note of what kind of tutor you'd like, along with some contact details, and we’ll get to work to find some suitable matches.
          </p>
          <form @submit.prevent="onSubmit" class="mt-9 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-8">
            <!-- <p class="text-sm text-gray-500 font-medium sm:col-span-2">Please provide some details about what kind of tutor you would like.</p> -->
            <div>
              <label for="subject" class="block text-sm font-medium text-gray-700">Subject and Level</label>
              <div class="mt-1">
                <input type="text" v-model="subject" name="subject" id="subject" placeholder="e.g. GCSE Maths" class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md">
              </div>
              <p v-if="$v.subject.$dirty && !$v.subject.required" class="text-sm text-red-600">Please enter a subject or level.</p>
            </div>
            <div>
              <label for="budget" class="block text-sm font-medium text-gray-700">Budget</label>
              <div class="mt-1">
                <input type="text" v-model="budget" name="budget" id="budget" placeholder="e.g. £25 per hour" class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md">
              </div>
              <p v-if="$v.budget.$dirty && !$v.budget.required" class="text-sm text-red-600">Please enter a budget.</p>
            </div>
            <fieldset class="">
              <legend class="block text-sm font-medium text-gray-700">
                How would you like to learn?
              </legend>
              <div class="mt-2 grid grid-cols-1 gap-y-2">
                <div class="flex items-center">
                  <input id="budget-under-25k" name="budget" v-model="tutoringMethod" value="online" type="radio" class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300">
                  <label for="budget-under-25k" class="ml-3">
                    <span class="block text-sm text-gray-700">Online</span>
                  </label>
                </div>
                <div class="flex items-center">
                  <input id="budget-25k-50k" name="budget" v-model="tutoringMethod" value="inperson" type="radio" class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300">
                  <label for="budget-25k-50k" class="ml-3">
                    <span class="block text-sm text-gray-700">In-person</span>
                  </label>
                </div>
                <div class="flex items-center">
                  <input id="budget-50k-100k" name="budget" v-model="tutoringMethod" value="either" type="radio" class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300">
                  <label for="budget-50k-100k" class="ml-3">
                    <span class="block text-sm text-gray-700">Either</span>
                  </label>
                </div>
              </div>
            </fieldset>
            <div v-show="tutoringMethod === 'inperson' || tutoringMethod === 'either'">
              <label for="postcode" class="block text-sm font-medium text-gray-700">Postcode</label>
              <div class="mt-1">
                <input type="text" v-model="postcode" name="postcode" id="postcode" class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md">
              </div>
              <p v-if="$v.postcode.$dirty && !$v.postcode.required && $v.postcode.$invalid" class="text-sm text-red-600">Please enter a postcode.</p>
            </div>

            <!-- <p class="text-sm text-gray-500 font-medium sm:col-span-2">Please provide some contact details we can use to get back in touch with you when we’ve found some tutors.</p> -->
            <fieldset class="sm:col-span-2">
              <legend class="block text-sm font-medium text-gray-700">
                Are you enquiring on behalf of yourself or someone else (e.g. a child)?
              </legend>
              <div class="mt-2 grid grid-cols-1 gap-y-2">
                <div class="flex items-center">
                  <input id="enquiry-myself" name="enquiry" v-model="onBehalfOf" value="myself" type="radio" class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300">
                  <label for="enquiry-myself" class="ml-3">
                    <span class="block text-sm text-gray-700">Myself</span>
                  </label>
                </div>
                <div class="flex items-center">
                  <input id="enquiry-another" name="enquiry" v-model="onBehalfOf" value="another" type="radio" class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300">
                  <label for="enquiry-another" class="ml-3">
                    <span class="block text-sm text-gray-700">Someone else</span>
                  </label>
                </div>
              </div>
            </fieldset>
            <div :class="{ 'sm:col-span-2': onBehalfOf === 'myself' }">
              <label for="name" class="block text-sm font-medium text-gray-700"><span v-show="onBehalfOf === 'another'">Your</span> Name</label>
              <div class="mt-1">
                <input type="text" v-model="name" name="name" id="name" autocomplete="name" class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md">
              </div>
              <p v-if="$v.name.$dirty && !$v.name.required" class="text-sm text-red-600">Please enter your name.</p>
            </div>
            <div v-show="onBehalfOf === 'another'">
              <label for="studentsName" class="block text-sm font-medium text-gray-700">Student’s Name</label>
              <div class="mt-1">
                <input type="text" v-model="studentsName" name="studentsName" id="studentsName" class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md">
              </div>
            </div>
            <!-- <div>
              <label for="last-name" class="block text-sm font-medium text-gray-700">Last name</label>
              <div class="mt-1">
                <input type="text" name="last-name" id="last-name" autocomplete="family-name" class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md">
              </div>
            </div> -->
            <div class="sm:col-span-2">
              <label for="email" class="block text-sm font-medium text-gray-700">Email</label>
              <div class="mt-1">
                <input id="email" v-model="email" name="email" type="email" autocomplete="email" class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md">
              </div>
              <p v-if="$v.email.$dirty && !$v.email.required" class="text-sm text-red-600">Please enter your email.</p>
              <p v-if="$v.email.$dirty && !$v.email.email" class="text-sm text-red-600">Please enter a valid email.</p>
            </div>
            <!-- <div class="sm:col-span-2">
              <div class="flex justify-between">
                <label for="phone" class="block text-sm font-medium text-gray-700">Phone</label>
                <span id="phone-description" class="text-sm text-gray-500">Optional</span>
              </div>
              <div class="mt-1">
                <input type="text" name="phone" id="phone" autocomplete="tel" aria-describedby="phone-description" class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md">
              </div>
            </div> -->
            <div class="sm:col-span-2">
              <div class="flex justify-between">
                <label for="how-can-we-help" class="block text-sm font-medium text-gray-700">Any other details</label>
                <!-- <span id="how-can-we-help-description" class="text-sm text-gray-500">Max. 500 characters</span> -->
              </div>
              <div class="mt-1">
                <textarea v-model="comments" id="how-can-we-help" name="how-can-we-help" aria-describedby="how-can-we-help-description" rows="4" class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-indigo-500 border border-gray-300 rounded-md"></textarea>
              </div>
            </div>
            <!-- <fieldset class="sm:col-span-2">
              <legend class="block text-sm font-medium text-gray-700">
                Expected budget
              </legend>
              <div class="mt-4 grid grid-cols-1 gap-y-4">
                <div class="flex items-center">
                  <input id="budget-under-25k" name="budget" value="under_25k" type="radio" class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300">
                  <label for="budget-under-25k" class="ml-3">
                    <span class="block text-sm text-gray-700">Less than $25K</span>
                  </label>
                </div>
                <div class="flex items-center">
                  <input id="budget-25k-50k" name="budget" value="25k-50k" type="radio" class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300">
                  <label for="budget-25k-50k" class="ml-3">
                    <span class="block text-sm text-gray-700">$25K – $50K</span>
                  </label>
                </div>
                <div class="flex items-center">
                  <input id="budget-50k-100k" name="budget" value="50k-100k" type="radio" class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300">
                  <label for="budget-50k-100k" class="ml-3">
                    <span class="block text-sm text-gray-700">$50K – $100K</span>
                  </label>
                </div>
                <div class="flex items-center">
                  <input id="budget-over-100k" name="budget" value="over_100k" type="radio" class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300">
                  <label for="budget-over-100k" class="ml-3">
                    <span class="block text-sm text-gray-700">$100K+</span>
                  </label>
                </div>
              </div>
            </fieldset> -->
            <!-- <div class="sm:col-span-2">
              <label for="how-did-you-hear-about-us" class="block text-sm font-medium text-gray-700">How did you hear about us?</label>
              <div class="mt-1">
                <input type="text" name="how-did-you-hear-about-us" id="how-did-you-hear-about-us" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md">
              </div>
            </div> -->
            <div class="text-right sm:col-span-2">
              <TtiButton
                type="submit"
                :loading="submitting"
                :disabled="submitting"
              >
                Submit
              </TtiButton>
              <p v-if="$v.$dirty && $v.$invalid" class="mt-2 text-sm text-red-600">Please review form errors.</p>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>


  <TtiFooter></TtiFooter>

</div>
</template>

<script>
import { required, requiredIf, email } from 'vuelidate/lib/validators'

import FindATutorService from '@/services/FindATutorService'
const findATutorService = new FindATutorService()

export default {
  components: {
    'TtiHeader': () => import('./HeaderNew'),
    'TtiFooter': () => import('./Footer'),
    'TtiButton': () => import('./TailwindButton'),
  },
  data() {
    return {
      subject: null,
      budget: null,
      tutoringMethod: 'either',
      postcode: null,
      onBehalfOf: 'myself',
      studentsName: null,
      name: null,
      email: null,
      comments: null,
      submitting: false,
      submitted: false,
    }
  },
  validations: {
    subject: {
      required
    },
    budget: {
      required
    },
    postcode: {
      required: requiredIf(vm => {
        return vm.tutoringMethod === 'either' || vm.tutoringMethod === 'inperson'
      })
    },
    name: {
      required
    },
    email: {
      required,
      email
    }
  },
  methods: {
    async onSubmit() {
      this.$v.$touch()
      if (this.$v.$invalid) return
      
      this.submitting = true

      try {
        await findATutorService.submitFindMeATutor({ 
          subject: this.subject,
          budget: this.budget,
          tutoringMethod: this.tutoringMethod,
          postcode: this.postcode, 
          onBehalfOf: this.onBehalfOf,
          name: this.name, 
          studentsName: this.studentsName,
          email: this.email, 
          comments: this.comments
        })
      }
      catch(error) {
        console.log(error)
        return
      }
      finally {
        this.submitting = false
      }

      this.submitted = true
    }
  }
}
</script>

<style>

</style>